import { Carousel, CarouselSlides } from '@jouzen/ecom-components/v4/Carousel';
import { useEffect, useRef, useState } from 'react';

import type { CurrentRouteValues } from '../_hooks/useCurrentRoute';
import HeroCarouselNav from './HeroCarouselNav';
import HeroCarouselSlide, {
  type HeroCarouselSlideProps,
} from './HeroCarouselSlide';

export interface HeroCarouselProps {
  readonly currentRoute: CurrentRouteValues;
  readonly slides: HeroCarouselSlideProps[];
}

const HeroCarousel = ({ currentRoute, slides }: HeroCarouselProps) => {
  const [resetSlides, setResetSlides] = useState<boolean>(false);
  const previousRoute = useRef(currentRoute.finish.value);

  // Reset slides when finish changes
  useEffect(() => {
    if (previousRoute.current !== currentRoute.finish.value) {
      setResetSlides(true);
      const timeout = setTimeout(() => setResetSlides(false), 0);
      return () => clearTimeout(timeout);
    }
    previousRoute.current = currentRoute.finish.value;
    return () => undefined;
  }, [currentRoute.finish.value, previousRoute]);

  return (
    <Carousel
      autoplay
      className="w-full max-lg:h-[70svh] lg:aspect-[6/5] lg:max-h-[80svh]"
      data-cy="hero-carousel"
      infinite
      resetSlides={resetSlides}
    >
      <CarouselSlides className="lg:rounded-r-3xl">
        {slides.map((slide, i) => (
          <HeroCarouselSlide
            {...slide}
            index={i}
            key={`hero-carousel-slide-${i}`}
          />
        ))}
      </CarouselSlides>
      <HeroCarouselNav />
    </Carousel>
  );
};

export default HeroCarousel;
